import React from 'react';
import { render } from 'react-dom';
import BeefBracketVoteTallyApp from './apps/BeefBracket/BeefBracketVoteTallyApp';

// Interests Application
const beefBracketVoteTallyApp = document.getElementById(
  'beef-bracket-vote-tally'
);
if (beefBracketVoteTallyApp) {
  render(
    <BeefBracketVoteTallyApp {...beefBracketVoteTallyApp.dataset} />,
    beefBracketVoteTallyApp
  );
}

// Display view for Beef Bracket Vote Tally
const beefBracketVoteTallyDisplay = document.getElementById(
  'beef-bracket-vote-tally-display'
);
if (beefBracketVoteTallyDisplay) {
  render(
    <BeefBracketVoteTallyApp {...beefBracketVoteTallyDisplay.dataset} />,
    beefBracketVoteTallyDisplay
  );
}
